import { IAsyncActionCallback } from '@state/types';
import * as actionsTypes from './constants';
import * as actionsInterfaces from './types';

export const fetchBrandImages = (query?:string, start?:number, length?:number, update?: string, callback?: (result: any, error: any) => void): actionsInterfaces.IFetchBrandImagesAction => {
  return {
    type: actionsTypes.FETCH_BRAND_IMAGES,
    query,
    start,
    length,
    update,
    callback
  };
};

export const fetchBrandImage = (id:string, callback?: (result: any, error: any) => void): actionsInterfaces.IFetchBrandImageAction => {
  return {
    type: actionsTypes.FETCH_BRAND_IMAGE,
    id,
    callback
  };
};

export const addBrandImages = (brandImages: actionsInterfaces.IBrandImage[], callback: IAsyncActionCallback): actionsInterfaces.IPostBrandImagesAction => {
  return {
    type: actionsTypes.ADD_BRAND_IMAGES,
    brandImages,
    callback
  };  
};

export const updateBrandImages = (brandImages: actionsInterfaces.IBrandImage[], callback?: (result: any, error: any) => void): actionsInterfaces.IUpdateBrandImagesAction => {
  return {
    type: actionsTypes.UPDATE_BRAND_IMAGES,
    brandImages,
    callback
  };
};

export const fetchBrandsVehicles = (year: string, make: string, model: string, trim:string, imgtype:string, start:number, length:number, oem?:string, search?:string, userdata?:string, callback?: (result: any, error: any) => void): actionsInterfaces.IFetchBrandsVehiclesAction => {
  return {
    type: actionsTypes.FETCH_BRAND_VEHICLES,    
    year,
    make,
    model,
    trim,
    imgtype,
    start,
    length, 
    oem,
    search,
    userdata,
    callback
  };
};

export const fetchBrandsVehiclesChromeData = (year: string, make: string, model: string, trim:string, imgtype:string, callback?: (result: any, error: any) => void): actionsInterfaces.IFetchBrandsVehiclesChromeDataAction => {
  return {
    type: actionsTypes.FETCH_BRAND_VEHICLESCHROMEDATA,
    year,
    make,
    model,
    trim,
    imgtype,
    callback
  };
};

export const setBrandImage = (image: actionsInterfaces.IBrandImage): actionsInterfaces.ISetBrandImage => {
  return {
    type: actionsTypes.SET_BRAND_IMAGES,
    image:image
  };
};


export const fetchBrandsLogos = (oem?:string, logotype?:string, callback?: (result: any, error: any) => void): actionsInterfaces.IFetchBrandsLogosAction => {
  return {
    type: actionsTypes.FETCH_BRAND_LOGOS,
    oem,
    logotype,
    callback
  };
};


export const setBrandLogos = (logo: actionsInterfaces.IBrandLogo): actionsInterfaces.ISetBrandLogos => {
  return {
    type: actionsTypes.SET_BRAND_IMAGES,
    id: logo.id,
    name: logo.name,
    logotype: logo.logotype,
    images:logo.images
  };
};


export const fetchBrandImagesFilters = (typestate: string, query?:string, callback?: (result: any, error: any) => void): actionsInterfaces.IFetchBrandImagesFiltersAction => {
  return {
    type: actionsTypes.FETCH_BRAND_IMAGES_FILTERS,
    typestate,
    query,
    callback
  };
};

export const setBrandImagesFilters = (filters?: actionsInterfaces.IOemFilter[], typestate?: string): actionsInterfaces.ISetBrandImagesFilters => {
  return {
    type: actionsTypes.SET_BRAND_IMAGES_FILTERS,
    filters: filters,
    typestate: typestate
  };
};


export const getExternalImage = (url?:string, callback?: (result: any, error: any) => void): actionsInterfaces.IGetExternalImageAction => {
  return {
    type: actionsTypes.GET_EXTERNAL_IMAGE,
    url,
    callback
  };
};

export const setBrandImages = (brandImages: actionsInterfaces.IBrandImage[]): actionsInterfaces.ISetBrandImages => {
  return {
    type: actionsTypes.SET_FETCH_BRAND_IMAGES,
    brandImages:brandImages
  };
};

export const setBrandImagesSearch = (brandImages: actionsInterfaces.IBrandImage[]): actionsInterfaces.ISetBrandImages => {
  return {
    type: actionsTypes.SET_FETCH_BRAND_IMAGES_SEARCH,
    brandImages:brandImages
  };
};

export const setBrandImagesSection = (brandImages: actionsInterfaces.IBrandImage[]): actionsInterfaces.ISetBrandImages => {
  return {
    type: actionsTypes.SET_FETCH_BRAND_IMAGES_SECTION,
    brandImages:brandImages
  };
};

export const fetchBrandsImagesOem = (oem?:string,imageType?:string, metadata?:string, callback?: (result: any, error: any) => void): actionsInterfaces.IFetchBrandsImagesOemAction => {
  return {
    type: actionsTypes.FETCH_BRAND_IMAGES_OEM,    
    oem,
    imageType,
    metadata,
    callback
  };
};


export const setBrandImagesOem = (image: actionsInterfaces.IBrandImagesOem): actionsInterfaces.ISetBrandImagesOem => {
  return {
    type: actionsTypes.SET_BRAND_IMAGES,
    id: image.id,
    name: image.name,
    itype: image.itype,
    images:image.images
  };
};

export const fetchCounterBrandImages = (filter?:string, typestate?: string, callback?: (result: any, error: any) => void): actionsInterfaces.IFetchCounterAction => {
  return {
    type: actionsTypes.FETCH_COUNTER_BRAND_IMAGES,
    filter,
    typestate,
    callback
  };
};

export const setCounterBrandImages = (counterBrandImages: any, typestate?: string): actionsInterfaces.ISetCounterAction => {
  return {
    type: actionsTypes.SET_COUNTER_BRAND_IMAGES,
    counterBrandImages,
    typestate
  };
};